import React from "react";
import { ServicesCtx, type ServicesType } from "services/Services";

/**
 * Core's `Services` starts PostHog with Novelica's project key. This app has
 * no analytics yet (same owner decision as the truelovelica.com site), so it
 * gives core a tracking object that does nothing instead.
 */
const noTracking: ServicesType = {
  tracking: {
    trackEvent: () => {},
    identify: () => {},
  },
};

export function NoTrackingServices({ children }: React.PropsWithChildren) {
  return (
    <ServicesCtx.Provider value={noTracking}>{children}</ServicesCtx.Provider>
  );
}
